import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "company-sso-configuration" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "alert alert-info" }, [
            /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-info-circle me-2" }),
            /*#__PURE__*/ _createTextVNode(),
            /*#__PURE__*/ _createElementVNode("strong", null, "Single Sign-On (SSO) Configuration"),
            /*#__PURE__*/ _createTextVNode(),
            /*#__PURE__*/ _createElementVNode("p", { class: "mb-0 mt-2" }, "\r\n\t\t\t\t\t\tConfigure OpenID Connect authentication for this company. Users will authenticate through your identity provider (Azure AD, Okta, Keycloak, etc.).\r\n\t\t\t\t\t")
        ])
    ])
], -1 /* HOISTED */);
const _hoisted_3 = { class: "col-12 mb-3" };
const _hoisted_4 = { class: "form-check form-switch" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("label", {
    class: "form-check-label fw-bold",
    for: "ssoEnabledSwitch"
}, "\r\n\t\t\t\t\t\tEnable SSO Authentication\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("small", { class: "text-muted ms-4" }, "\r\n\t\t\t\t\tWhen enabled, users from this company will authenticate via your SSO provider\r\n\t\t\t\t", -1 /* HOISTED */);
const _hoisted_7 = { class: "sso-fields" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
        /*#__PURE__*/ _createElementVNode("h5", { class: "text-muted mb-3" }, [
            /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-cog me-2" }),
            /*#__PURE__*/ _createTextVNode("Identity Provider Settings\r\n\t\t\t\t\t")
        ])
    ])
], -1 /* HOISTED */);
const _hoisted_9 = { class: "d-flex flex-wrap" };
const _hoisted_10 = { class: "col-md-6 mb-3" };
const _hoisted_11 = { class: "form-label required" };
const _hoisted_12 = {
    class: "fa fa-question-circle text-muted",
    title: "The URL of your identity provider (e.g., https://login.microsoftonline.com/{tenant-id}/v2.0)"
};
const _hoisted_13 = {
    key: 0,
    class: "invalid-feedback"
};
const _hoisted_14 = { class: "col-md-6 mb-3" };
const _hoisted_15 = { class: "form-label required" };
const _hoisted_16 = {
    class: "fa fa-question-circle text-muted",
    title: "Unique subdomain for this company (e.g., 'acme' for acme.yourdomain.com)"
};
const _hoisted_17 = {
    key: 0,
    class: "invalid-feedback"
};
const _hoisted_18 = { class: "text-muted" };
const _hoisted_19 = { class: "d-flex flex-wrap" };
const _hoisted_20 = { class: "col-md-6 mb-3" };
const _hoisted_21 = { class: "form-label required" };
const _hoisted_22 = {
    class: "fa fa-question-circle text-muted",
    title: "Application/Client ID from your SSO provider"
};
const _hoisted_23 = {
    key: 0,
    class: "invalid-feedback"
};
const _hoisted_24 = { class: "col-md-6 mb-3" };
const _hoisted_25 = {
    class: "fa fa-question-circle text-muted",
    title: "Client secret from your SSO provider (stored encrypted)"
};
const _hoisted_26 = {
    key: 0,
    class: "invalid-feedback"
};
const _hoisted_27 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_28 = { class: "d-flex flex-wrap" };
const _hoisted_29 = { class: "col-md-6 mb-3" };
const _hoisted_30 = { class: "form-label" };
const _hoisted_31 = {
    class: "fa fa-question-circle text-muted",
    title: "Comma-separated list of OAuth scopes to request"
};
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\tDefault: openid, profile, email\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_33 = /*#__PURE__*/ _createStaticVNode("<div class=\"mt-3\"><div class=\"col-12\"><h5 class=\"text-muted mb-3\"><i class=\"fa fa-user-tag me-2\"></i>Claim Mappings\r\n\t\t\t\t\t</h5> <p class=\"text-muted small\">\r\n\t\t\t\t\t\tSpecify which claims from your SSO provider contain user information. Use defaults for standard OIDC providers.\r\n\t\t\t\t\t</p></div></div>", 1);
const _hoisted_34 = { class: "d-flex flex-wrap" };
const _hoisted_35 = { class: "col-md-3 mb-3" };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("label", { class: "form-label" }, "Username Claim", -1 /* HOISTED */);
const _hoisted_37 = { class: "col-md-3 mb-3" };
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("label", { class: "form-label" }, "Email Claim", -1 /* HOISTED */);
const _hoisted_39 = { class: "col-md-3 mb-3" };
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("label", { class: "form-label" }, "First Name Claim", -1 /* HOISTED */);
const _hoisted_41 = { class: "col-md-3 mb-3" };
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("label", { class: "form-label" }, "Last Name Claim", -1 /* HOISTED */);
const _hoisted_43 = { class: "d-flex flex-wrap" };
const _hoisted_44 = { class: "col-md-6 mb-3" };
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("label", { class: "form-label" }, "Roles Claim Type", -1 /* HOISTED */);
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\tThe claim that contains user roles/groups from SSO provider\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_47 = /*#__PURE__*/ _createStaticVNode("<div class=\"mt-3\"><div class=\"col-12\"><h5 class=\"text-muted mb-3\"><i class=\"fa fa-users me-2\"></i>Role Mappings\r\n\t\t\t\t\t</h5> <p class=\"text-muted small\">\r\n\t\t\t\t\t\tMap SSO roles/groups from your identity provider to application roles. \r\n\t\t\t\t\t\tEnter the exact role or group name as it appears in your SSO provider.\r\n\t\t\t\t\t</p></div></div>", 1);
const _hoisted_48 = { class: "d-flex flex-wrap" };
const _hoisted_49 = {
    key: 0,
    class: "col-md-4 mb-3"
};
const _hoisted_50 = { class: "form-label" };
const _hoisted_51 = {
    class: "fa fa-question-circle text-muted",
    title: "SSO role/group name that maps to Administrator (e.g., 'admin.1', 'Admins')"
};
const _hoisted_52 = /*#__PURE__*/ _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\tFull system administrator access\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_53 = {
    key: 1,
    class: "col-md-4 mb-3"
};
const _hoisted_54 = { class: "form-label" };
const _hoisted_55 = {
    class: "fa fa-question-circle text-muted",
    title: "SSO role/group name that maps to Power User (e.g., 'PowerUser', 'Power Users')"
};
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\tAdvanced user with elevated permissions\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_57 = { class: "form-label" };
const _hoisted_58 = {
    class: "fa fa-question-circle text-muted",
    title: "SSO role/group name that maps to Client (e.g., 'Client', 'Users')"
};
const _hoisted_59 = /*#__PURE__*/ _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\tStandard user access\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_60 = { class: "d-flex flex-wrap" };
const _hoisted_61 = { class: "form-label" };
const _hoisted_62 = {
    class: "fa fa-question-circle text-muted",
    title: "SSO role/group name that maps to Client Administrator (e.g., 'ClientAdmin', 'Client Admins')"
};
const _hoisted_63 = /*#__PURE__*/ _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\tClient-level administrator access\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_64 = { class: "form-label" };
const _hoisted_65 = {
    class: "fa fa-question-circle text-muted",
    title: "SSO role/group name that maps to Client Installer (e.g., 'Installer', 'Installers')"
};
const _hoisted_66 = /*#__PURE__*/ _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\tInstaller/technician access\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_67 = /*#__PURE__*/ _createElementVNode("div", { class: "mt-3" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
        /*#__PURE__*/ _createElementVNode("h5", { class: "text-muted mb-3" }, [
            /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-shield-alt me-2" }),
            /*#__PURE__*/ _createTextVNode("User Provisioning\r\n\t\t\t\t\t")
        ])
    ])
], -1 /* HOISTED */);
const _hoisted_68 = { class: "col-12 mb-3" };
const _hoisted_69 = { class: "form-check" };
const _hoisted_70 = /*#__PURE__*/ _createElementVNode("label", {
    class: "form-check-label",
    for: "autoAssignSwitch"
}, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Auto-assign all sites and systems to new SSO users")
], -1 /* HOISTED */);
const _hoisted_71 = /*#__PURE__*/ _createElementVNode("small", { class: "text-muted ms-4" }, "\r\n\t\t\t\t\t\tWhen enabled, newly created SSO users automatically get access to all sites and systems in this company.\r\n\t\t\t\t\t\tWhen disabled, access must be manually assigned by an administrator.\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_72 = { class: "mt-3" };
const _hoisted_73 = { class: "col-12" };
const _hoisted_74 = { class: "alert alert-warning" };
const _hoisted_75 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1 /* HOISTED */);
const _hoisted_76 = /*#__PURE__*/ _createElementVNode("strong", null, "Important:", -1 /* HOISTED */);
const _hoisted_77 = /*#__PURE__*/ _createElementVNode("br", null, null, -1 /* HOISTED */);
const _hoisted_78 = { class: "mt-2 d-block" };
const _hoisted_79 = /*#__PURE__*/ _createElementVNode("br", null, null, -1 /* HOISTED */);
const _hoisted_80 = { class: "mt-2" };
const _hoisted_81 = { class: "col-12" };
const _hoisted_82 = { class: "card" };
const _hoisted_83 = { class: "card-body" };
const _hoisted_84 = /*#__PURE__*/ _createElementVNode("h6", { class: "card-title text-muted" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-cogs me-2" }),
    /*#__PURE__*/ _createTextVNode("Advanced Settings\r\n\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_85 = { class: "col-md-6 mb-3" };
const _hoisted_86 = { class: "form-label" };
const _hoisted_87 = {
    class: "fa fa-question-circle text-muted",
    title: "Redirect URI path (must match configuration in your SSO provider)"
};
const _hoisted_88 = /*#__PURE__*/ _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\t\t\t\t\tDefault: /signin-oidc (only change if required by your SSO provider)\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_button = _resolveComponent("b-button");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "ssoEnabledSwitch",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.config.ssoEnabled) = $event)),
                        onChange: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.onSsoEnabledChanged && _ctx.onSsoEnabledChanged(...args)))
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [_vModelCheckbox, _ctx.config.ssoEnabled]
                    ]),
                    _createTextVNode(),
                    _hoisted_5
                ]),
                _createTextVNode(),
                _hoisted_6
            ])
        ]),
        _createTextVNode(),
        _createCommentVNode(" SSO Configuration Fields (shown only when enabled) "),
        _createTextVNode(),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, [
                        _createTextVNode("\r\n\t\t\t\t\t\tAuthority URL\r\n\t\t\t\t\t\t"),
                        _withDirectives(_createElementVNode("i", _hoisted_12, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ]),
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.authority,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.config.authority) = $event)),
                        modelModifiers: { trim: true },
                        type: "url",
                        placeholder: "https://login.microsoftonline.com/your-tenant-id/v2.0",
                        class: _normalizeClass({ 'is-invalid': _ctx.showValidation && !_ctx.config.authority }),
                        maxlength: "500"
                    }, null, 8 /* PROPS */, ["modelValue", "class"]),
                    _createTextVNode(),
                    (_ctx.showValidation && !_ctx.config.authority)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "\r\n\t\t\t\t\t\tAuthority URL is required when SSO is enabled\r\n\t\t\t\t\t"))
                        : _createCommentVNode("v-if", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, [
                        _createTextVNode("\r\n\t\t\t\t\t\tSubdomain\r\n\t\t\t\t\t\t"),
                        _withDirectives(_createElementVNode("i", _hoisted_16, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ]),
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.subdomain,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.config.subdomain) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "acme",
                        class: _normalizeClass({ 'is-invalid': _ctx.showValidation && !_ctx.config.subdomain }),
                        maxlength: "100",
                        onInput: _ctx.validateSubdomain
                    }, null, 8 /* PROPS */, ["modelValue", "class", "onInput"]),
                    _createTextVNode(),
                    (_ctx.showValidation && !_ctx.config.subdomain)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, "\r\n\t\t\t\t\t\tSubdomain is required when SSO is enabled\r\n\t\t\t\t\t"))
                        : _createCommentVNode("v-if", true),
                    _createTextVNode(),
                    _createElementVNode("small", _hoisted_18, [
                        _createTextVNode("\r\n\t\t\t\t\t\tURL: "),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.subdomainPreview), 1 /* TEXT */)
                    ])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, [
                        _createTextVNode("\r\n\t\t\t\t\t\tClient ID\r\n\t\t\t\t\t\t"),
                        _withDirectives(_createElementVNode("i", _hoisted_22, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ]),
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.clientId,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.config.clientId) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "your-client-id",
                        class: _normalizeClass({ 'is-invalid': _ctx.showValidation && !_ctx.config.clientId }),
                        maxlength: "200"
                    }, null, 8 /* PROPS */, ["modelValue", "class"]),
                    _createTextVNode(),
                    (_ctx.showValidation && !_ctx.config.clientId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, "\r\n\t\t\t\t\t\tClient ID is required when SSO is enabled\r\n\t\t\t\t\t"))
                        : _createCommentVNode("v-if", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", {
                        class: _normalizeClass(["form-label", { 'required': _ctx.isNewSsoConfig }])
                    }, [
                        _createTextVNode("\r\n\t\t\t\t\t\tClient Secret\r\n\t\t\t\t\t\t"),
                        _withDirectives(_createElementVNode("i", _hoisted_25, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ], 2 /* CLASS */),
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.clientSecret,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.config.clientSecret) = $event)),
                        modelModifiers: { trim: true },
                        type: "password",
                        placeholder: _ctx.isNewSsoConfig ? 'Enter client secret' : 'Leave blank to keep existing secret',
                        class: _normalizeClass({ 'is-invalid': _ctx.showValidation && _ctx.isNewSsoConfig && !_ctx.config.clientSecret }),
                        maxlength: "1000"
                    }, null, 8 /* PROPS */, ["modelValue", "placeholder", "class"]),
                    _createTextVNode(),
                    (_ctx.showValidation && _ctx.isNewSsoConfig && !_ctx.config.clientSecret)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, "\r\n\t\t\t\t\t\tClient Secret is required for new SSO configuration\r\n\t\t\t\t\t"))
                        : _createCommentVNode("v-if", true),
                    _createTextVNode(),
                    (!_ctx.isNewSsoConfig)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_27, "\r\n\t\t\t\t\t\tLeave blank to keep the existing secret\r\n\t\t\t\t\t"))
                        : _createCommentVNode("v-if", true)
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("label", _hoisted_30, [
                        _createTextVNode("\r\n\t\t\t\t\t\tOAuth Scopes\r\n\t\t\t\t\t\t"),
                        _withDirectives(_createElementVNode("i", _hoisted_31, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ]),
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.scopesString,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.scopesString) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "openid, profile, email",
                        maxlength: "500"
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createTextVNode(),
                    _hoisted_32
                ])
            ]),
            _createTextVNode(),
            _hoisted_33,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.userNameClaimType,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.config.userNameClaimType) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "preferred_username",
                        maxlength: "100"
                    }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.emailClaimType,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.config.emailClaimType) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "email",
                        maxlength: "100"
                    }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.firstNameClaimType,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.config.firstNameClaimType) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "given_name",
                        maxlength: "100"
                    }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.lastNameClaimType,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.config.lastNameClaimType) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "family_name",
                        maxlength: "100"
                    }, null, 8 /* PROPS */, ["modelValue"])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.rolesClaimType,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.config.rolesClaimType) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "roles",
                        maxlength: "100"
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createTextVNode(),
                    _hoisted_46
                ])
            ]),
            _createTextVNode(),
            _hoisted_47,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_48, [
                (!_ctx.isCloudHosting)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createElementVNode("label", _hoisted_50, [
                            _createTextVNode("\r\n\t\t\t\t\t\tAdministrator Role\r\n\t\t\t\t\t\t"),
                            _withDirectives(_createElementVNode("i", _hoisted_51, null, 512 /* NEED_PATCH */), [
                                [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                ]
                            ])
                        ]),
                        _createTextVNode(),
                        _createVNode(_component_b_form_input, {
                            modelValue: _ctx.administratorRole,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.administratorRole) = $event)),
                            modelModifiers: { trim: true },
                            type: "text",
                            placeholder: "e.g., admin.1",
                            maxlength: "200"
                        }, null, 8 /* PROPS */, ["modelValue"]),
                        _createTextVNode(),
                        _hoisted_52
                    ]))
                    : _createCommentVNode("v-if", true),
                _createTextVNode(),
                (!_ctx.isCloudHosting)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createElementVNode("label", _hoisted_54, [
                            _createTextVNode("\r\n\t\t\t\t\t\tPower User Role\r\n\t\t\t\t\t\t"),
                            _withDirectives(_createElementVNode("i", _hoisted_55, null, 512 /* NEED_PATCH */), [
                                [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                ]
                            ])
                        ]),
                        _createTextVNode(),
                        _createVNode(_component_b_form_input, {
                            modelValue: _ctx.powerUserRole,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.powerUserRole) = $event)),
                            modelModifiers: { trim: true },
                            type: "text",
                            placeholder: "e.g., PowerUser",
                            maxlength: "200"
                        }, null, 8 /* PROPS */, ["modelValue"]),
                        _createTextVNode(),
                        _hoisted_56
                    ]))
                    : _createCommentVNode("v-if", true),
                _createTextVNode(),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-md-4 mb-3", { 'col-md-6': _ctx.isCloudHosting }])
                }, [
                    _createElementVNode("label", _hoisted_57, [
                        _createTextVNode("\r\n\t\t\t\t\t\tClient Role\r\n\t\t\t\t\t\t"),
                        _withDirectives(_createElementVNode("i", _hoisted_58, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ]),
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.clientRole,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.clientRole) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "e.g., Client",
                        maxlength: "200"
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createTextVNode(),
                    _hoisted_59
                ], 2 /* CLASS */)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", {
                    class: _normalizeClass(["col-md-4 mb-3", { 'col-md-6': _ctx.isCloudHosting }])
                }, [
                    _createElementVNode("label", _hoisted_61, [
                        _createTextVNode("\r\n\t\t\t\t\t\tClient Administrator Role\r\n\t\t\t\t\t\t"),
                        _withDirectives(_createElementVNode("i", _hoisted_62, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ]),
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.clientAdministratorRole,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.clientAdministratorRole) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "e.g., ClientAdmin",
                        maxlength: "200"
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createTextVNode(),
                    _hoisted_63
                ], 2 /* CLASS */),
                _createTextVNode(),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-md-4 mb-3", { 'col-md-6': _ctx.isCloudHosting }])
                }, [
                    _createElementVNode("label", _hoisted_64, [
                        _createTextVNode("\r\n\t\t\t\t\t\tClient Installer Role\r\n\t\t\t\t\t\t"),
                        _withDirectives(_createElementVNode("i", _hoisted_65, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ]),
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.clientInstallerRole,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.clientInstallerRole) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "e.g., Installer",
                        maxlength: "200"
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createTextVNode(),
                    _hoisted_66
                ], 2 /* CLASS */)
            ]),
            _createTextVNode(),
            _hoisted_67,
            _createTextVNode(),
            _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                        _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: "autoAssignSwitch",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.config.autoAssignAllSitesAndSystems) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                            [_vModelCheckbox, _ctx.config.autoAssignAllSitesAndSystems]
                        ]),
                        _createTextVNode(),
                        _hoisted_70
                    ]),
                    _createTextVNode(),
                    _hoisted_71
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                        _hoisted_75,
                        _createTextVNode(),
                        _hoisted_76,
                        _createTextVNode(" After configuring SSO, you must register the following callback URL in your identity provider:\r\n\t\t\t\t\t\t"),
                        _hoisted_77,
                        _createTextVNode(),
                        _createElementVNode("code", _hoisted_78, _toDisplayString(_ctx.callbackUrlPreview), 1 /* TEXT */),
                        _createTextVNode(),
                        _hoisted_79,
                        _createTextVNode(),
                        _createVNode(_component_b_button, {
                            size: "sm",
                            variant: "link",
                            class: "p-0 mt-2",
                            onClick: _cache[18] || (_cache[18] = ($event) => (_ctx.showAdvancedSettings = !_ctx.showAdvancedSettings))
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("i", {
                                    class: _normalizeClass(_ctx.showAdvancedSettings ? 'fa fa-chevron-up' : 'fa fa-chevron-down')
                                }, null, 2 /* CLASS */),
                                _createTextVNode(" " + _toDisplayString(_ctx.showAdvancedSettings ? 'Hide' : 'Show') + " Advanced Settings\r\n\t\t\t\t\t\t", 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ])
            ]),
            _createTextVNode(),
            _createCommentVNode(" Advanced Settings "),
            _createTextVNode(),
            _withDirectives(_createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                            _hoisted_84,
                            _createTextVNode(),
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_85, [
                                    _createElementVNode("label", _hoisted_86, [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tCallback Path\r\n\t\t\t\t\t\t\t\t\t\t"),
                                        _withDirectives(_createElementVNode("i", _hoisted_87, null, 512 /* NEED_PATCH */), [
                                            [
                                                _directive_b_tooltip,
                                                void 0,
                                                void 0,
                                                { hover: true }
                                            ]
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createVNode(_component_b_form_input, {
                                        modelValue: _ctx.config.callbackPath,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.config.callbackPath) = $event)),
                                        modelModifiers: { trim: true },
                                        type: "text",
                                        placeholder: "/signin-oidc",
                                        maxlength: "200"
                                    }, null, 8 /* PROPS */, ["modelValue"]),
                                    _createTextVNode(),
                                    _hoisted_88
                                ])
                            ])
                        ])
                    ])
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.showAdvancedSettings]
            ])
        ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.config.ssoEnabled]
        ])
    ]));
}
